module.exports = __webpack_public_path__ + "img/patrick-okeefe-running-late.83d0635.jpg";